import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional().nullable(),
  ngay_ct2: z.string().optional().nullable(),
  so_ct1: z.string().nullable().optional(),
  so_ct2: z.string().nullable().optional(),
  loai_du_lieu: z.string().nullable().optional(),

  ma_kh: z.string().nullable().optional(),
  nh_kh1: z.string().nullable().optional(),
  nh_kh2: z.string().nullable().optional(),
  nh_kh3: z.string().nullable().optional(),
  rg_code: z.string().nullable().optional(),
  ma_vt: z.string().nullable().optional(),
  ma_lvt: z.string().nullable().optional(),
  ton_kho_yn: z.boolean().nullable().optional(),
  nh_vt1: z.string().nullable().optional(),
  nh_vt2: z.string().nullable().optional(),
  nh_vt3: z.string().nullable().optional(),
  ma_kho: z.string().nullable().optional(),
  ma_unit: z.string().nullable().optional(),
  mau_bc: z.number().nullable().optional(),

  ma_bp: z.string().nullable().optional(),
  ma_vv: z.string().nullable().optional(),
  ma_hd: z.string().nullable().optional(),
  ma_dtt: z.string().nullable().optional(),
  ma_ku: z.string().nullable().optional(),
  ma_phi: z.string().nullable().optional(),
  ma_sp: z.string().nullable().optional(),
  ma_lsx: z.string().nullable().optional(),
  ma_cp0: z.string().nullable().optional(),

  ma_gd: z.string().nullable().optional(),
  tk_vt: z.string().nullable().optional(),
  tk_dt: z.string().nullable().optional(),
  tk_gv: z.string().nullable().optional(),
  ma_lo: z.string().nullable().optional(),
  ma_vi_tri: z.string().nullable().optional(),
  dien_giai: z.string().nullable().optional(),
  report_filtering: z.string().nullable().optional(),
  data_analysis_struct: z.string().nullable().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  so_ct1: '',
  so_ct2: '',
  loai_du_lieu: '1',

  ma_kh: '',
  nh_kh1: '',
  nh_kh2: '',
  nh_kh3: '',
  rg_code: '',
  ma_vt: '',
  ma_lvt: '',
  ton_kho_yn: true,
  nh_vt1: '',
  nh_vt2: '',
  nh_vt3: '',
  ma_kho: '',
  ma_unit: '',
  mau_bc: 20,

  ma_bp: '',
  ma_vv: '',
  ma_hd: '',
  ma_dtt: '',
  ma_ku: '',
  ma_phi: '',
  ma_sp: '',
  ma_lsx: '',
  ma_cp0: '',

  ma_gd: '',
  tk_vt: '',
  tk_dt: '',
  tk_gv: '',
  ma_lo: '',
  ma_vi_tri: '',
  dien_giai: '',
  report_filtering: '0',
  data_analysis_struct: ''
};
